module.exports = __webpack_public_path__ + "img/即将开始.16d698c8.png";